import { render } from "./HeroiconsSolidAtSymbol.vue?vue&type=template&id=12e3ed40"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAtSymbol.vue"]])

export default __exports__